import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../lib/api";
import useSEO from "../lib/useSEO";

export default function BlogDetail() {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    useSEO({ title: post?.title, description: post?.excerpt, path: `/blog/${slug}` });

    useEffect(() => {
        api.get(`/blog/${slug}`).then(({ data }) => setPost(data)).catch(() => setPost(false));
    }, [slug]);

    if (post === null) return <div className="max-w-7xl mx-auto px-4 py-24 font-mono-cap text-xs text-slate-500">Loading…</div>;
    if (post === false) return (
        <div className="max-w-3xl mx-auto px-4 py-24 text-center">
            <p>Post not found.</p>
            <Link to="/blog" className="rj-link">Back to Insights</Link>
        </div>
    );

    return (
        <article data-testid={`page-blog-${slug}`}>
            {post.cover_url && (
                <div className="relative h-[40vh] md:h-[55vh]">
                    <img src={post.cover_url} alt={post.title} className="w-full h-full object-cover" />
                    <div className="absolute inset-0 rj-overlay" />
                </div>
            )}
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <Link to="/blog" className="font-mono-cap text-xs text-slate-500 inline-flex items-center gap-2 hover:text-[#c5a059]">
                    <ArrowLeft className="w-3 h-3" /> All Insights
                </Link>
                <div className="font-mono-cap text-xs text-[#c5a059] mt-6">{post.category}</div>
                <h1 className="font-serif-display text-3xl md:text-5xl text-slate-900 mt-2 leading-tight">{post.title}</h1>
                <div className="text-sm text-slate-500 mt-3 italic">By {post.author}</div>
                <div className="rj-rule-gold w-12 my-8" />
                <div className="prose text-slate-800 leading-relaxed whitespace-pre-line text-[17px]">{post.content}</div>
            </div>
        </article>
    );
}
